define('modules/editor/behaviours/movable',['require','exports','module','../models/editorstate'],function(require, exports, module){
	"use strict";

	var EditorState = require("../models/editorstate"),
			MoveState = EditorState.moveState,
      GroupState = EditorState.groupState;

	/**
	 * Movable events
	 * @type {Object}
	 */
	var MovableEvents = {
		"mousedown": "_onMovableMouseDown"
	};


	/**
	 * jQuery selectors defining the possible droppable views
	 * They can be overriden by- the View by setting the prototype
	 * dropTargets property.
	 * @type {Array}
	 */
	var DefaultDropTargets = [
		/**
		 * Section elements class selector
		 */
		".ed-item-section",
    ".ed-item-area"
	];

	//store drappable target elements for collision detection
	var targets = [];

	/**
	 * Binds mouse event handlers and prevents selection
	 * on the whole page
	 */
	var _bindMouseHandlers = function(){
		//bind events for dragging and stopping
		$(document).on("mousemove", _continueDragging);
		$(document).on("mouseup", _endDrag);
		$(".js-page").addClass("noselect");
	};
	/**
	 * Unbinds mouse event handlers and removes whole page CSS class
	 * that prevents selecting
	 * @return {[type]}
	 */
	var _unbindMouseHandlers = function(){
		$(document).unbind("mousemove", _continueDragging);
		$(document).unbind("mouseup", _endDrag);
		$(".js-page").removeClass("noselect");
	};
  
  var _areAllSelectedElementsInside = function(target) {
    var absPos = GroupState.getGroupAbsoluteDimensions();
    return absPos.left >= target.left && 
           absPos.right <= target.right && 
           absPos.top >= target.top && 
           absPos.bottom <= target.bottom;
  };

	/**
	 * Event handler for mouse move event
	 * @param  {Event} e
	 */
	var _continueDragging = function(e){
		//update the location of the moving view
    var lastPos = GroupState.getGroupAbsoluteDimensions(),
        offset = MoveState.getClickOffset(),
        dx = e.pageX - offset.left - lastPos.left,
        dy = e.pageY - offset.top - lastPos.top,
        snap = EditorState.get("snap") || {x: false, y:false};

    if (Math.abs(dx) > 15 || !snap.x) {
      GroupState.updatePosition(dx, 0);
      snap.x = false;
    }
    if (Math.abs(dy) > 15 || !snap.y) {
      GroupState.updatePosition(0, dy);
      snap.y = false;
    }
    
    EditorState.set("snap", snap);

    var target;
    var _voidTarget = function(target) {
      if (target) {
        target.over = false;
        target.dom.trigger("lpg.dragout", e);
      }
    };
    //collision detection
    for(var i in targets){
      if (_areAllSelectedElementsInside(targets[i])){
        if (!target || targets[i].dom.hasClass("ed-item-area")) {
          _voidTarget(target);
          target = targets[i];
        }
      }	else if(targets[i].over){
        //we were over something but we aren't now
        _voidTarget(targets[i]);
      }
    }

    //drag over target
    if (target) {
      target.dom.trigger("lpg.dragover", e);
      target.over = true;
    }
    
    GroupState.elements.toggleClass("offlimits", !target);
		//store absolute coords
		MoveState.setLastPosition(e.pageX, e.pageY);
	};

	/**
	 * Event handler for mouseup event
	 * @param  {Event} e
	 */
	var _endDrag = function(e){
		var movingItem = MoveState.getMovingView(),
        target,
				originalPos;

		//remove event listeners
		_unbindMouseHandlers();
		//drop detection
		for(var i in targets){
      if (_areAllSelectedElementsInside(targets[i])){
        if (!target || (target && targets[i].dom.hasClass("ed-item-area"))) {
          target = targets[i];
        }
      }
		}

    if (target) {
      //drop on target
      target.dom.trigger("lpg.drop");
      target.over = true;
      //remove inline style so the generated stylesheet are not overriden
			movingItem.$el.css({
				left: "",
				top: ""
			});
			EditorState.selectElement(movingItem);
    } else {
      GroupState.elements.each(restoreOriginalPosition);
      EditorState.selectElement(GroupState.getFirstView());
    }

		targets = [];
		MoveState.stopMoving();
	};

  function restoreOriginalPosition(movingItem){
    //failed drop, outside any valid 
    var movingView = movingItem.get("view"),
        originalPos = movingView.model.getPosition();
        //selectedElement = EditorState.getSelectedElement();
        // TODO: this should be revisited to make it work:
        //isMovingViewSelected = movingView == selectedElement;
        //animate back to original position
    movingView.$el.animate(
      {
        left: originalPos.x,
        top: originalPos.y
      },
      {
        duration: 200,
        start: function(){
          //EditorState.deselect();
        },
        complete: function(){
          //clean up inline styles
          movingView.$el.removeClass("offlimits").css({
            left: "",
            top: ""
          });
          movingItem.setRelativePosition(originalPos);
          //re-select moving item after failed drop
          //EditorState.selectElement(movingView);
        }
      }
    );
  }

	/**
	 * Movable View Behaviour
	 * Handles drag & drop moving of elements ALREADY in the editor
	 * @type {Object}
	 */
	var Movable = {
		_onMovableMouseDown: function(e){
			//left button only
			if(e.which !== 1) {
				return;
			}
			e.stopPropagation();
			e.stopImmediatePropagation();
			//deselect the item while moving
			EditorState.deselect();
			//find valid drop targets - they should have the Droppable behaviour
      var view = this;
			$(this.dropTargets.join(",")).each(function(){
        if (!$(this).hasClass("ed-item-area") || !view.$el.hasClass("ed-item-area")) {
          var pos = $(this).offset();
          targets.push({
            dom: $(this),
            left: pos.left,
            top: pos.top,
            right: pos.left + $(this).width(),
            bottom: pos.top + $(this).height(),
            over: false
          });
        }
			});
			//store the click offset to be able to drag / drop with accuracy
			var clickOffset; // =  || {top: this.$el.offset().top, left: this.$el.offset().left},
      //update group state
      //Using shift adds/removes from group
      if(e.shiftKey && GroupState.isInTheSameSection(this)){
        if(this.model._grouped){
          GroupState.remove(this);
          //TODO: if there's only one left in group, select it!
          if(GroupState.getGroupCount() === 1){
            EditorState.selectElement(GroupState.getFirstView());
          }
        }
        else {
          GroupState.add(this);
          //keep a reference to the moving view
          clickOffset = {
            top: e.pageY - GroupState.getGroupAbsoluteDimensions().top,
            left: e.pageX - GroupState.getGroupAbsoluteDimensions().left
          };
          MoveState.startMoving(this, clickOffset);
          MoveState.setLastPosition(e.pageX, e.pageY);
          _bindMouseHandlers();
        }
      }
      //clicking on a non grouped view creates a new group with it
      else {
        if(!this.model._grouped){
          GroupState.clear();
          GroupState.add(this);
        }
        clickOffset = {
          top: e.pageY - GroupState.getGroupAbsoluteDimensions().top,
          left: e.pageX - GroupState.getGroupAbsoluteDimensions().left
        };
        //keep a reference to the moving view
        MoveState.startMoving(this, clickOffset);
        MoveState.setLastPosition(e.pageX, e.pageY);
        _bindMouseHandlers();
      }

		},
		mixed: function(klass, proto){
			proto.events = _.extend(proto.events || {}, MovableEvents);
			//allow invidual views to define its own drop targets via jQuery selectors
			proto.dropTargets = proto.dropTargets || DefaultDropTargets;
		}
	};

	module.exports = Movable;
});

